export const baseUrl = "https://hccapi.mobifone5.vn/hccqnivangdanh"
// export const baseUrl = "http://10.40.55.24:6005"
export default {
    baseUrl
}
